import React, { useState, useEffect } from 'react';
import Pin from './Pin/Pin';
import axios from 'axios';

const labels = {
  area_media: 'Área média',
  ticket_medio_metro: 'Ticket Médio R$/m²',
  total_unidades: 'Oferta Inicial',
  oferta_final: 'Estoque',
};

const Legenda = ({ ranges }) => {
  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const loadMarkers = async () => {
      try {
        const localMarkers = localStorage.getItem('markers');
        if (localMarkers && isMounted) {
          setMarkers(JSON.parse(localMarkers));
          return;
        }

        const response = await axios.get(route('building-markers'));
        if (response.status === 200 && isMounted) {
          setMarkers(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    loadMarkers();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div>
      <table className="table table-striped table-condensed legenda-mapa">
        <thead>
          <tr>
            <th colSpan="2" style={{ paddingBottom: 7 }}>
              <span
                className="font-weight-bold text-center"
                style={{ color: 'rgb(0, 72, 14)', fontSize: 16 }}
              >
                LEGENDA
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {ranges.map((range) => {
            const image = range.marker.type === 'image' ? range.marker.value : null;
            const hexaBackground = range.marker.type === 'color' ? range.marker.background : null;

            return (
              <tr key={range.id}>
                <td>
                  {hexaBackground && (
                    <Pin
                      backgroundColor={hexaBackground}
                      borderColor={range.marker.borderColor}
                      glyphColor={range.marker.glyphColor}
                    />
                  )}
                  {image && <img src={image} alt="marker" />}
                </td>
                <td>
                  {range.type === 'padroes' ? (
                    range.padroes.toString()
                  ) : (
                    <>
                      {labels[range.type]} a partir de {Number(range.min).toLocaleString()}
                      {range.max !== 99999999 && ` até ${Number(range.max).toLocaleString()}`}
                    </>
                  )}
                </td>
              </tr>
            );
          })}

          {markers.map((marker) => {
            const randomNumber = Math.floor(Math.random() * (999999 - 100000)) + 100000;
            const key = `${marker.status}.${marker.tipo}.${marker.status}.${randomNumber}`;

            return (
              <tr key={key}>
                <td>
                  <img src={marker.icon} alt={`${marker.tipo} icon`} />
                </td>
                <td>{`${marker.tipo} ${marker.padrao} ${marker.status}`}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Legenda;
